import { NavLink } from 'react-router-dom';
import classNames from 'classnames';
import React, { forwardRef } from 'react';

export const NavbarItemMobile = forwardRef(
    ({ name, icon, to, onClick, showInfo, info }, ref) => {
        return (
            <NavLink
                ref={ref}
                className={({ isActive }) => {
                    return classNames('navbar__item', {
                        navbar__item_selected: to && isActive,
                    });
                }}
                to={to}
                onClick={onClick}
            >
                <span className="navbar__item__icon">{icon}</span>
                <span className="navbar__item__name">{name}</span>
                {showInfo && (
                    <div className={'searchbar-item__info'}>{info}</div>
                )}
            </NavLink>
        );
    }
);
